/* eslint-disable import/prefer-default-export */
import { IntlShape } from "react-intl";

export function getServiceTranslations(label: string, intl: IntlShape) {
  if (!label) return "";
  switch (label.toLowerCase()) {
    case "door to door":
      return intl.formatMessage({
        id: "service.doorToDoor",
        defaultMessage: "Door to door",
      });
    case "door to port":
      return intl.formatMessage({
        id: "service.doorToPort",
        defaultMessage: "Door to port",
      });
    case "port to port":
      return intl.formatMessage({
        id: "service.portToPort",
        defaultMessage: "Port to port",
      });
    case "port to door":
      return intl.formatMessage({
        id: "service.portToDoor",
        defaultMessage: "Port to door",
      });
    default:
      return label;
  }
}
